<template>
  <div class="hold-all">

    <router-view />
  </div>
</template>

<style lang="scss">
.hold-all {
  background-color: #fff;
  color: #121212;
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: 80px;
}
</style>
